export const sections = [
  { id: 'inicio', label: 'Início' },
  { id: 'quem-pode-participar', label: 'Quem pode participar?' },
  { id: 'datas', label: 'Datas' },
  { id: 'adesao-beneficios', label: 'Adesão e benefícios por categoria' },
  { id: 'beneficios', label: 'Benefícios' },
  { id: 'acesso-plataforma', label: 'Acesso à plataforma exclusiva' },
  { id: 'condicoes-oferta', label: 'Condições da oferta' },
  { id: 'encerramento', label: 'Encerramento' },
  { id: 'central-de-atendimento', label: 'Central de atendimento' }
]
